import { EnvironmentBanner } from "@common/components/layout";
import { ClientSearchButton } from '@common/components/layout/nav/ClientSearchButton';
import { NavBarLink } from '@common/components/layout/nav/NavBarLink';
import NavBarProfile from '@common/components/layout/nav/NavBarProfile';
import { Authorized } from '@common/components/trimming/Authorized';
import { EnvironmentWarning } from '@common/components/utility';
import { useApp } from '@common/hooks';
import { FeatureFlags } from "@common/models/Enums";
import { AuthOperationUINames } from '@common/models/Enums/AuthOperationStrings';
import { useHospitalApp } from '@hospital/hooks';
import { useDocumentsCheck } from "@hospital/hooks/useDocumentsCheck";
import { usePriceCheck } from "@hospital/hooks/usePriceCheck";
import { observer } from 'mobx-react';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { NavLink as NavLinkRR } from 'react-router-dom';
import uniqid from 'uniqid';


export const HospitalMainNavBar = observer(() => {
	const { configuration } = useApp();
	const hospitalAppStore = useHospitalApp();
	const hasCurrentHospital = hospitalAppStore.hasCurrentHospital;
	const currentHospital = hospitalAppStore.currentHospital;
	const hospitalId = currentHospital ? currentHospital.hospitalId : 0;
	const { priceCheckModal, priceCheckButton } = usePriceCheck();
	const { documentCheckButton } = useDocumentsCheck({ route: `/${currentHospital?.hospitalId}/documents` });
	return (
		<>
			<Navbar className="main-nav more-sticky" bg="primary" sticky="top" variant="dark" expand="xl" id={uniqid()}>
				<Container fluid>
					<Navbar.Brand className="petco-logo" as={NavLinkRR} to="/"></Navbar.Brand>

					<Nav className="root-links ms-xl-5">
						{
							currentHospital &&
							<NavBarLink route={`/${currentHospital.hospitalId}/home`} name={currentHospital.name} />
						}
						<Nav.Item className="position-absolute bottom-2 align-self-center"><EnvironmentWarning
							isForHeader /></Nav.Item>
					</Nav>
					<Navbar.Toggle />
					<Navbar.Collapse>
						<div className="d-flex flex-row flex-fill">
							<div className="d-flex flex-fill justify-content-evenly">
								<Nav className="mb-2 mb-lg-0 page-links align-self-center">
									{
										hasCurrentHospital && <>

											<NavBarLink route={`/${hospitalId}/dashboard`} name="Dashboard" />
											<NavBarLink route={`/${hospitalId}/calendar`} name="Calendar" />
											<NavBarLink route={`/${hospitalId}/flow`} name="Flow" />
											<NavBarLink route={`/${hospitalId}/tasks`} name="Tasks"
												notificationCount={hospitalAppStore.openTaskSearch !== undefined ? (hospitalAppStore.openTaskSearch.searchResults.totalRecordCount ?? undefined) : undefined} />
											<NavBarLink route={`/${hospitalId}/billing`} name="Billing" />
											<NavBarLink route={`/${hospitalId}/labs`} name="Labs" />
											{configuration.hasFeatureFlag(FeatureFlags.AllowPrescriptionTable) && <NavBarLink route={`/${hospitalId}/prescriptions `} name="Prescriptions" />}
											{
												configuration.hasFeatureFlag(FeatureFlags.InAppSms)
													? <NavBarLink
														route={`/${hospitalId}/communications`}
														name="Communications"
														notificationCount={hospitalAppStore.unreadMessageClientCount !== 0 ? hospitalAppStore.unreadMessageClientCount : undefined}
													/>
													: undefined
											}
											<NavBarLink route={`/${hospitalId}/myhospital`} name="My Hospital Setup" />
											<NavBarLink route={`/${hospitalId}/faqs`} name="What's New?" target="_blank" />
											<Authorized
												if={configuration.HasUIFlag(AuthOperationUINames.UI_HospitalFlags_CanAccessHospitalAdmin)}>
												<NavBarLink route="/admin" name="Admin" />
											</Authorized>
										</>
									}
								</Nav>
								{
									hasCurrentHospital &&
									<div className="d-flex">
										{documentCheckButton}
										{priceCheckButton}
										<ClientSearchButton store={hospitalAppStore.clientSearchStore} />
									</div>
								}
							</div>
							{/*TODO: Margin top 1px might not be the best approach*/}
							<div className="d-flex justify-content-end" style={{ marginTop: "1px" }} >
								<div className="align-item-end">
									<NavBarProfile userId={configuration.userId}
										userInitials={configuration.userInitials}
										firstName={configuration.firstName}
										lastName={configuration.lastName} />
								</div>
							</div>
						</div>
					</Navbar.Collapse>
				</Container>
				<EnvironmentBanner />
			</Navbar>
			{priceCheckModal}
		</>
	);
});


export default HospitalMainNavBar;
